import React from 'react';
import AppCard from './AppCard';

export default function AppCards(props) {

    const {apps, rowSize, rows} = props;

    const cards = [];

    const containerStyles = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'bottom',
    };

    const rowStyles = {
        width: 'auto',
        display: 'flex',
        justifyContent: 'center',
        marginTop: 20,
    };

    for (let row = 0; row < rows; ++row) {
        const rowCards = [];
        for (let card = 0; card < rowSize; ++card) {
            const index = (rowSize * row) + card;
            if (!apps[index]) {
                if (row > 0) {
                    rowStyles.justifyContent = null;
                }
                continue;
            }
            rowCards.push(<AppCard key={'app-card-' + index} app={apps[index]}/>);
        }

        cards.push(<div style={rowStyles} key={'row-' + row}>{rowCards}</div>);
    }

    return <div style={containerStyles}>{cards}</div>;

}